import TermCondition from 'modules/term-and-condition';

export default TermCondition;
